export const degreeToRadians = (degree: number): number => {
  return (degree * Math.PI) / 180
}
